import { Injectable, Injector } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class SequencerGuard implements CanActivate {

  constructor(private injector: Injector) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

      const guards: CanActivate[] = [];
      const guardNames: string[] = next.data['guardSequence'];
      for (let guardName of guardNames) {
        guards.push(this.injector.get(guardName));
      }

      return guards
        .reduce((promise, guard) =>
           promise.then(value => value && this.canActivateAsPromise(guard, next, state)), Promise.resolve(true));
  }

  private canActivateAsPromise(guard: CanActivate, next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    let promise: Promise<boolean>;
    const result = guard.canActivate(next, state);
    if (typeof(result) === 'boolean') {
      promise = new Promise<boolean>((resolve) => {resolve(result)});
    } else if (result instanceof Promise) {
      promise = result;
    } else if (result instanceof Observable) {
      promise = result.toPromise();
    }

    return Promise.resolve(true).then(value => promise);
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/sequencer.guard.ts